import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import Checkout from './pages/Checkout';
import Cart from './pages/Cart';
import OrderSummary from './pages/OrderSummary';
import OrderComplete from './pages/OrderComplete';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Login from './components/Login';
import Register from './components/Register';
import Home from './pages/Home';
import Shop from './pages/Shop';
import AdminDashboard from './pages/AdminDashboard';
import Unauthorized from './pages/Unauthorized';
import TestEmail from './pages/TestEmail';
import ProductDetail from './pages/ProductDetail';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <Router>
    <div className="App">
          <Navigation />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route 
              path="/login" 
              element={
                <ProtectedRoute requireAuth={false}>
                  <Login />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <ProtectedRoute requireAuth={false}>
                  <Register />
                </ProtectedRoute>
              } 
            />
            
            {/* Public routes */}
            <Route path="/home" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            
            {/* Admin only routes */}
            <Route path="/admin" element={<Navigate to="/admin-dashboard" replace />} />
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute requireAuth={true} allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
                           {/* Test routes */}
               <Route path="/test-email" element={<TestEmail />} />

               {/* Product routes */}
               <Route path="/product/:productId" element={<ProductDetail />} />
               <Route path="/checkout" element={<Checkout />} />
               <Route path="/order-summary" element={<OrderSummary />} />
               <Route path="/order-complete" element={<OrderComplete />} />
               <Route path="/cart" element={<Cart />} />

               {/* Error routes */}
               <Route path="/unauthorized" element={<Unauthorized />} />
               <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
    </div>
      </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
